<div class="ct-overlay">
  <div *ngIf="firstModal" class="ct-modal">
    <img class="cm-icon" [src]="modalFunctionIcon" alt="" />
    <div class="cm-msg-one">{{ contentToPrint?.header | translate }}</div>
    <div
      [ngClass]="contentToPrint?.extraContent ? 'cm-msg-three' : 'cm-msg-two'"
    >
      {{ contentToPrint?.content | translate }}
    </div>
    <div class="cm-msg-two" *ngIf="contentToPrint?.extraContent">
      {{ contentToPrint?.extraContent | translate }}
    </div>
    <div class="cm-msg-two">{{ contentToPrint?.text | translate }}</div>
    <div class="cm-btn-grp">
      <button class="cm-btn-dark" (click)="logoutOrSwitch($event)">
        <span *ngIf="LogoutButtonValue !== 'Loading...'">{{
          LogoutButtonValue | translate
        }}</span>
        <span
          *ngIf="LogoutButtonValue === 'Loading...'"
          class="btn-white-loader"
        ></span>
        <img
          class="arrow-right-icon"
          src="assets/icons/arrow-right.svg"
          *ngIf="
            LogoutButtonValue === 'Logout' ||
            LogoutButtonValue === 'Yes' ||
            LogoutButtonValue === 'Continue'
          " alt="arrow-right"
        />
      </button>
      <button class="cm-btn-light" (click)="cancel()">
        {{ "Cancel" | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="!firstModal" class="ct-modal">
    <img
      class="cm-icon"
      [src]="
        successData
          ? 'assets/icons/success-tick.svg'
          : 'assets/icons/error-icon.svg'
      "
      alt=""
    />
    <div class="cm-msg-one" *ngIf="successData">
      {{ successData | translate }}
    </div>
    <div class="cm-msg-two">{{ successDataMsg | translate }}</div>
    <div class="cm-msg-two" *ngIf="errorData">
      {{ errorData | translate }}
    </div>
    <div class="cm-msg-two" *ngIf="errorsData">
      {{ errorsData | translate }}
    </div>
    <div class="cm-btn-grp">
      <button class="cm-btn-dark" (click)="refreshPage()">
        {{ "OK" | translate }}
        <img class="arrow-right-icon" src="assets/icons/arrow-right.svg" alt="arrow-right" />
      </button>
    </div>
  </div>
</div>
